import { forwardRef } from 'react';
import { useIntl } from 'react-intl';

import { Container } from '@/components/Container';
import { InputField } from '@/components/InputField';
import { TextAreaField } from '@/components/TextAreaField';
import { Typography } from '@/components/Typography';
import { GIFT_MESSAGE_MAX_LENGTH, MAX_CHAR } from '@/lib/forms/const';
import { generateFieldPrefix } from '@/lib/forms/helpers';
import { commonMessages } from '@/messages/common';

import * as M from '../messages';
interface GiftFormProps {
  message: string;
  schemaPrefix: string;
}

export const GiftForm = forwardRef<HTMLDivElement, GiftFormProps>(
  ({ message, schemaPrefix }, ref) => {
    const { formatMessage } = useIntl();
    const withSchemaPrefix = generateFieldPrefix(schemaPrefix);
    const giftMessageRemainingLength = GIFT_MESSAGE_MAX_LENGTH - message.length;

    return (
      <Container
        ref={ref}
        backgroundColor='mediumGrey'
        data-test-id='GiftFormContainer'
        m={2}
        p={2}
      >
        <Typography data-test-id='GiftFormTypography' mb='s075' scale='p2'>
          {M.PersonalizeYourGiftMessage}
        </Typography>
        <InputField
          data-test-id='GiftFormInputField-from'
          maxLength={MAX_CHAR}
          name={withSchemaPrefix('from')}
          placeholder={formatMessage(commonMessages.from)}
          required
        />
        <br />
        <TextAreaField
          data-test-id='GiftFormTextAreaField-message'
          data-testid='GiftFormTextAreaField-message'
          maxLength={GIFT_MESSAGE_MAX_LENGTH}
          name={withSchemaPrefix('message')}
          placeholder={formatMessage(commonMessages.composeYourMessage)}
          required
          rows={4}
        />
        <Typography
          data-test-id='GiftFormTypography-RemainingCharacters'
          my='s075'
          scale='p3'
        >
          {M.RemainingCharacters}: {giftMessageRemainingLength}
        </Typography>
      </Container>
    );
  },
);

GiftForm.displayName = 'GiftForm';
